import {createSlice} from '@reduxjs/toolkit';

interface chequeInfo {
    chequeId: number;
    chequeType: string;
}

const initialState: chequeInfo = {
    chequeId: 0,
    chequeType: '',
};

export const chequeInfoSlice = createSlice({
    name: 'chequeInfo',
    initialState,
    reducers: {
        setchequeInfo: (state: any, action: any) => {
            state.chequeId = action.payload.chequeId;
            state.chequeType = action.payload.chequeType;
        },
    },
});

// this is for dispatch
export const {setchequeInfo}: any = chequeInfoSlice.actions;

// this is for configureStore
export default chequeInfoSlice.reducer;
